import request from '@/utils/request'

/**
* 获取积分商城列表
* @param {*} params {pageNo, pageSize}
* @returns 
*/
export function getGoodsList(params) {
    return request.post("/goods/list", params)
}

/**
* 获取商品详情
* @param {*} id 商品ID 
* @returns 
*/
export function getGoodsDetail(id) {
    return request.post("/goods/goodsDetail", { id: id })
}

/**
* 获取订单id
* @param {*} params {goodsId, num}
* @returns 
*/
export function getOrderId(params) {
    return request.post("/goods/orderId", params)
}

/**
* 订单确认
* @param {*} params {orderId, payPwd}
* @returns 
*/
export function orderConfirm(params) {
    return request.post("/goods/score/orderConfirm", params)
}

/**
* 用户全部订单列表
* @param {*} params {pageNum, pageSize}
* @returns 
*/
export function getGoodsCustOrderList(params) {
    return request.post("/goods/custOrderList", params)
}

/**
* 兑换列表
* @param {*} params {pageNum, pageSize}
* @returns 
*/
export function getGoodsExchange(params) {
    return request.post("/goods/exchange", params)
}

/**
 * 根据订单ID获取购买积分列表
 * @param {*} orderId 订单ID
 * @returns 
 */
export function getscoreOrderInfo(orderId) {
    return request.post("/goods/scoreOrderInfo", { orderId: orderId })
}

/**
 * 获取撤销订单前的提示信息
 * @param {*} recordId 红包ID
 * @returns 
 */
export function getExchangeSingleOptions(recordId) {
    return request.post("/goods/exchangeSingleOption", { recordId: recordId })
}

/**
 * 代金券退换
 * @param {*} recordId 红包ID
 * @returns 
 */
export function undoExchangeCancelSingle(recordId) {
    return request.post("/goods/exchangeCancelSingle", { recordId: recordId })
}

export function goodsClassifiesList(parentId) {
    return request.post("/goodsClassifies/list", { parentId: parentId })
}

export function phoneCharge(params) {
    return request.post("/goods/phoneCharge", params)
}

export function wxPayResultQuery(params) {
    return request.post("/mch/query", params)
}

export function getGoodsRedPacket(goodsId) {
    return request.post("/redPacket/goodsRed", { goodsId: goodsId })
}

export function isGetGoodsRedPacket() {
    return request.post("/activity/goods/redpacket")
}

export function rewardRedpacket() {
    return request.post("/activity/goods/rewardRedpacket")
}